var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-decoration-none",attrs:{"href":_vm.getHref,"target":"_blank"},on:{"click":_vm.onClick}},[_vm._t("anchorBody")],2)}
var staticRenderFns = []

export { render, staticRenderFns }